import Layout, { Content, Header } from 'antd/lib/layout/layout';
import React, { Component, useEffect, useMemo, useRef, useState } from 'react';
import 'antd/dist/antd.min.css';
import '../styles/globals.css';
import '../styles/Message.css';
import {
    Button,
    ConfigProvider,
    DatePicker,
    Dropdown,
    Form,
    Menu,
    message,
    Spin,
    Tabs,
} from 'antd';
import { Icon, Spacer, Text } from '../styles/commonStyle';
import styled from 'styled-components';
import MessageTable from '../components/MessageTable';
import moment from 'moment';
import { CustomButton } from '../components/CustomButton';
import MessageSearchBar from '../components/MessageSearchBar';
import { useDispatch, useSelector } from 'react-redux';
import {
    getMessageHistoryAction,
    getPushNotificationHistoryAction,
    getKakaoAlimTalkHistoryAction,
    getKakaoAlimTalkCountAction,
    getMonoMessageHistoryAction,
    getMonoMessageHistoryCountAction,
    deleteReservedMonoMessageAction,
    clearDeleteReservedMonoMessageStatusAction,
} from '../reducers/message';
import _, { debounce } from 'lodash';
import CustomSpinner from '../components/CustomSpinner';
import locale from 'antd/lib/locale/ko_KR';
import 'moment/locale/ko';
import { useDateRangePicker } from '../hooks/useDateRangePicker';
import { commonTheme } from '../styles/theme';
import NoticeModal from '../components/NoticeModal';

moment.locale('ko');

const { RangePicker } = DatePicker;

const { TabPane } = Tabs;

const MenuItem = Menu.Item;

const menuStyle = {
    backgroundColor: '#4a4a4a',
};

const menuItemStyle = {
    background: 'none',
    color: '#ffffff',
    fontSize: '12px',
};

const HistoryTypeMenuItems = {
    send_history: '발송 내역',
    reserved_history: '예약 내역',
};

const kakaoHistoryTypeMenuItems = {
    logs: '발송 내역',
    // reserved: '예약 내역', // 2차에 진행하기로 했다가 무산, 추후 추가 예정 (관련 조건은 전체 구현되어있음)
};

const MessageTypeMenuItems = {
    total: '전체 메세지 타입',
    sms: 'SMS',
    lms: 'LMS',
    mms: 'MMS',
};

const HistoryTypeMenu = ({ handleChange, tabType }) => {
    let historyTypeMenuItems =
        tabType === 'message'
            ? HistoryTypeMenuItems
            : kakaoHistoryTypeMenuItems;

    return (
        <Menu style={menuStyle} defaultSelectedKeys={1} onChange={handleChange}>
            {Object.keys(historyTypeMenuItems).map((key) => {
                return (
                    <MenuItem
                        key={key}
                        style={menuItemStyle}
                        onClick={handleChange}
                    >
                        {historyTypeMenuItems[key]}
                    </MenuItem>
                );
            })}
        </Menu>
    );
};

const MessageTypeMenu = ({ handleChange }) => {
    return (
        <Menu style={menuStyle} defaultSelectedKeys={1} onChange={handleChange}>
            {Object.keys(MessageTypeMenuItems).map((key) => {
                return (
                    <MenuItem
                        key={key}
                        style={menuItemStyle}
                        onClick={handleChange}
                    >
                        {MessageTypeMenuItems[key]}
                    </MenuItem>
                );
            })}
            {/* <MenuItem key={"mms"} style={menuItemStyle} onClick={handleChange}>
        MMS
      </MenuItem> */}
        </Menu>
    );
};

const pageSize = 50;
// 대용량 요청 : 예. 메세지 내역(신) > 예약내역은 페이지네이션을 하지않음.(전체 선택 후 예약 삭제 고려)
const bulkPageSize = 5000;

// 기준일: 2025-05-31 (날짜만 비교)
// startTime: ISO string (예: '2025-06-01T00:00:00.000Z')
const isLegacyMessageHistoryDate = (endTime) => {
    if (!endTime) return false;
    const cutoff = moment.utc('2025-05-31').endOf('day'); // 2025-05-31 23:59:59 UTC
    const end = moment.utc(endTime).endOf('day');
    const useLegacy = end.isSameOrBefore(cutoff);
    return useLegacy;
};

// 메세지 내역(신)에 필요한 job_type (메세지 타입)을 formatting 하는 함수
const finalJobType = (selectedJobType) => {
    if (!selectedJobType) {
        return null;
    }
    if (selectedJobType === 'total') {
        return null;
    }
    return MessageTypeMenuItems[selectedJobType];
};

const MessageHistory = () => {
    const [tab, setTab] = useState('message');
    const [date, setDate] = useState(moment(new Date()));
    const [year, setYear] = useState(null);
    const [month, setMonth] = useState(moment(new Date()).format('YYYYMM'));
    const [index, setIndex] = useState(0); // 운톡 푸쉬 알림의 index state
    const [kakaoIndex, setKakaoIndex] = useState(0); // 알림톡의 index state
    const [pushFilter, setPushFilter] = useState(null);
    const [kakaoKeyword, setKakaoKeyword] = useState(null); // 알림톡 - 키워드 검색
    const [
        selectedKakaoHistoryTypeItemKey,
        setSelectedKakaoHistoryTypeItemKey,
    ] = useState(Object.keys(kakaoHistoryTypeMenuItems)[0]); // 알림톡 - 발송 내역 / 예약내역
    const [pushData, setPushData] = useState(null); // 운톡 푸쉬 알림 내역
    const [kakaoData, setKakaoData] = useState(null); // 알림톡 내역
    // 탭별 스크롤 위치 분리 - 다른 탭 스크롤이 현재 탭에 영향 안주도록
    const [scrollPositions, setScrollPositions] = useState({
        message: 0,
        push_notification: 0,
        kakao_alim_talk: 0,
    });

    const getScrollPosition = (tab) => scrollPositions[tab] || 0;
    const setScrollPosition = (tab, pos) =>
        setScrollPositions((prev) => ({ ...prev, [tab]: pos }));
    const [height, setHeight] = useState(0);
    // (구) 문자내역의 state
    const [messageData, setMessageData] = useState(null); // 문자 내역
    const [filter, setFilter] = useState(null); // 문자 내역의 filter
    const [selectedMessageTypeItemKey, setSelectedMessageTypeItemKey] =
        useState(Object.keys(MessageTypeMenuItems)[0]); // 문자 - 전체 메세지 타입 / LMS / SMS
    const [selectedHistoryTypeItemKey, setSelectedHistoryTypeItemKey] =
        useState(Object.keys(HistoryTypeMenuItems)[0]); // 문자 - 발송 내역 / 예약내역
    // (신) 문자 내역 - (차이점: 페이지네이션)
    const [monoMessageData, setMonoMessageData] = useState(null); // 문자 내역(신)
    const [monoMessageIndex, setMonoMessageIndex] = useState(0); // 문자의 index state
    const [monoMessageKeyword, setMonoMessageKeyword] = useState(null); // 문자 - 키워드 검색
    /** 예약 삭제 위한 states */
    const [selectedRowKeys, setSelectedRowKeys] = useState([]); // 문자내역 > 에약 삭제를 위한 체크박스 내 key들 담는 state
    const [selectedRows, setSelectedRows] = useState([]); // 문자내역 > 에약 삭제를 위한 체크박스 내 정보 담는 state
    const [reservationDeleteOpen, setReservationDeleteOpen] = useState(false); // 예약 삭제 모달을 띄우기 위한 state
    const [resetKey, setResetKey] = useState(0); // 탭 전환 시 스크롤 0 트리거

    /** 메세지 내역(구) 관련 전역 상태들 */
    // loading
    const getMessageHistoryLoading = useSelector(
        (state) => state.messageReducer.getMessageHistoryLoading,
    );
    // 메세지 내역 받아오는 list
    const sendedMessageList = useSelector(
        (state) => state.messageReducer.sendedMessageList,
    ); // 서버에서 받아서, 프론트에서 필터링 한 문자 발송 내역
    const reservedMessageList = useSelector(
        (state) => state.messageReducer.reservedMessageList,
    ); // 서버에서 받아서, 프론트에서 필터링 한 문자 예약 내역
    const sendedSmsList = useSelector(
        (state) => state.messageReducer.sendedSmsList,
    ); // 서버에서 받아서, 프론트에서 필터링 한 문자 발송 내역 > sms
    // const mmsList = useSelector((state) => state.messageReducer.mmsList);
    const sendedLmsList = useSelector(
        (state) => state.messageReducer.sendedLmsList,
    ); // 서버에서 받아서, 프론트에서 필터링 한 문자 발송 내역 > lms
    const reservedSmsList = useSelector(
        (state) => state.messageReducer.reservedSmsList,
    ); // 서버에서 받아서, 프론트에서 필터링 한 문자 예약 내역 > sms
    // const mmsList = useSelector((state) => state.messageReducer.mmsList);
    const reservedLmsList = useSelector(
        (state) => state.messageReducer.reservedLmsList,
    ); // 서버에서 받아서, 프론트에서 필터링 한 문자 예약 내역 > lms

    /** 메세지 내역(신) 관련 전역 상태들 */
    const {
        getMonoMessageHistoryLoading,
        getMonoMessageHistoryCountLoading,
        monoMessageList,
        monoMessageCount,
        deleteReservedMonoMessageDone,
        deleteReservedMonoMessageLoading,
        deleteReservedMonoMessageError,
    } = useSelector((state) => state.messageReducer);

    // push loading
    const getPushNotificationHistoryLoading = useSelector(
        (state) => state.messageReducer.getPushNotificationHistoryLoading,
    );
    const pushNotificationList = useSelector(
        (state) => state.messageReducer.pushNotificationList,
    ); // 운톡 푸쉬 알림
    const kakaoAlimTalkList = useSelector(
        (state) => state.messageReducer.kakaoAlimTalkList,
    ); // 알림톡
    const kakaoAlimTalkCount = useSelector(
        (state) => state.messageReducer.kakaoAlimTalkCount,
    ); // 알림톡 개수
    const { getKakaoAlimTalkHistoryLoading, getKakaoAlimTalkCountLoading } =
        useSelector((state) => state.messageReducer);

    const dispatch = useDispatch();
    const jgroupKey = useSelector(
        (state) => state.groupReducer.jgroup_key_inCookie,
    );

    // hooks로 꺼낸 datepicker 제어에 필요한 것들 가져오기
    // 운톡 푸쉬 알림
    const {
        startDate: pushStartDttm,
        endDate: pushEndDttm,
        setStartDate: setPushStartDttm,
        setEndDate: setPushEndDttm,
        handleStartChange: handlePushStartChange,
        handleEndChange: handlePushEndChange,
        startOpen: startPushOpen,
        endOpen: endPushOpen,
        handleStartOpenChange: handlePushStartOpenChange,
        handleEndOpenChange: handlePushEndOpenChange,
    } = useDateRangePicker({});

    // 알림톡
    const {
        startDate: kakaoStartDttm,
        endDate: kakaoEndDttm,
        setStartDate: setKakaoStartDttm,
        setEndDate: setKakaoEndDttm,
        handleStartChange: handleKakaoStartChange,
        handleEndChange: handleKakaoEndChange,
        startOpen: startKakaoOpen,
        endOpen: endKakaoOpen,
        handleStartOpenChange: handleKakaoStartOpenChange,
        handleEndOpenChange: handleKakaoEndOpenChange,
    } = useDateRangePicker({
        maxRangeDays: 100,
    });

    const onTabChange = (key) => {
        setTab(key);
        // 검색/ 기간/ 인덱스는 건드리지 않고, 스크롤만 최상단으로 이동
        setScrollPosition(key, 0);
        setResetKey((prev) => prev + 1);
    };

    const handleHistoryTypeMenuItem = (item) => {
        switch (tab) {
            case 'message':
                {
                    if (isLegacy) {
                        setSelectedHistoryTypeItemKey(item.key);
                        return;
                    }
                    setScrollPosition('message', 0); // 발송/예약 내역 변경 시 스크롤 초기화
                    setMonoMessageIndex(0);
                    setResetKey((prev) => prev + 1); // 스크롤 강제 초기화
                    dispatch(
                        getMonoMessageHistoryAction({
                            params: setMessageParams({
                                date: moment(date).format('YYYYMM'),
                                page: 0,
                                keyword: monoMessageKeyword,
                                job_type: finalJobType(
                                    selectedMessageTypeItemKey,
                                ),
                                type: item.key || 'send_history',
                            }),
                            type: item.key || 'send_history',
                        }),
                    );
                    dispatch(
                        getMonoMessageHistoryCountAction({
                            params: setMessageCountParams({
                                date: moment(date).format('YYYYMM'),
                                keyword: monoMessageKeyword,
                                job_type: finalJobType(
                                    selectedMessageTypeItemKey,
                                ),
                            }),
                            type: item.key || 'send_history',
                        }),
                    );
                    setSelectedHistoryTypeItemKey(item.key);
                }
                break;
            case 'kakao_alim_talk':
                {
                    setScrollPosition('kakao_alim_talk', 0); // 카카오 내역 변경 시 스크롤 초기화
                    setIndex(0);
                    setResetKey((prev) => prev + 1); // 스크롤 강제 초기화
                    setKakaoIndex(0);
                    // list 다시 부르기
                    dispatch(
                        getKakaoAlimTalkHistoryAction({
                            params: setKakaoAlimTalkParams({
                                search_start_time: kakaoStartDttm.toISOString(),
                                search_end_time: kakaoEndDttm.toISOString(),
                                page: 0,
                                keyword: kakaoKeyword,
                            }),
                            type: item.key || 'logs',
                        }),
                    );
                    // count
                    dispatch(
                        getKakaoAlimTalkCountAction({
                            params: setKakaoAlimTalkCountParams({
                                search_start_time: kakaoStartDttm.toISOString(),
                                search_end_time: kakaoEndDttm.toISOString(),
                                keyword: kakaoKeyword,
                            }),
                            type: item.key || 'logs',
                        }),
                    );
                    // 발송 내역 / 예약내역 set
                    setSelectedKakaoHistoryTypeItemKey(item.key);
                }
                break;
        }
    };

    const handleMessageTypeMenuItem = (item) => {
        if (isLegacy) {
            setSelectedMessageTypeItemKey(item.key);
            return;
        }
        // 메세지 내역(신)의 경우 - 메세지 타입 변경 시 스크롤 초기화
        setScrollPosition('message', 0);
        setMonoMessageIndex(0);
        setResetKey((prev) => prev + 1); // 스크롤 강제 초기화

        dispatch(
            getMonoMessageHistoryAction({
                params: setMessageParams({
                    date: moment(date).format('YYYYMM'),
                    page: 0,
                    keyword: monoMessageKeyword,
                    job_type: finalJobType(item.key),
                    type: selectedHistoryTypeItemKey || 'send_history',
                }),
                type: selectedHistoryTypeItemKey || 'send_history',
            }),
        );
        dispatch(
            getMonoMessageHistoryCountAction({
                params: setMessageCountParams({
                    date: moment(date).format('YYYYMM'),
                    keyword: monoMessageKeyword,
                    job_type: finalJobType(item.key),
                }),
                type: selectedHistoryTypeItemKey || 'send_history',
            }),
        );
        setSelectedMessageTypeItemKey(item.key);
    };

    const onMessageKeywordChange = (e) => {
        setFilter(e.target.value);
    };

    const handleKeywordChange = (e, tab) => {
        if (tab === 'message') {
            if (isLegacy) {
                return onMessageKeywordChange(e);
            }
            // return 새로운 함수 (메세지 내역 (신))
            return onMonoMessageKeywordChange(e);
        }
        // 카카오 알림톡의 경우
        return onKakaoAlimKeywordChange(e);
    };

    // 메세지 내역 신 / 구 확인용 변수
    const isLegacy = useMemo(() => {
        return isLegacyMessageHistoryDate(
            moment(date, 'YYYYMM').endOf('month').toISOString(),
        );
    }, [date]);

    // 알림톡 디바운스 된 함수 정의
    const debouncedSearch = useMemo(() => {
        return debounce((value) => {
            dispatch(
                getKakaoAlimTalkHistoryAction({
                    params: setKakaoAlimTalkParams({
                        search_start_time: kakaoStartDttm.toISOString(),
                        search_end_time: kakaoEndDttm.toISOString(),
                        page: kakaoIndex,
                        keyword: value,
                    }),
                    type: selectedKakaoHistoryTypeItemKey,
                }),
            );
            // count
            dispatch(
                getKakaoAlimTalkCountAction({
                    params: setKakaoAlimTalkCountParams({
                        search_start_time: kakaoStartDttm.toISOString(),
                        search_end_time: kakaoEndDttm.toISOString(),
                        keyword: value,
                    }),
                    type: selectedKakaoHistoryTypeItemKey,
                }),
            );
        }, 500);
    }, [
        kakaoStartDttm,
        kakaoEndDttm,
        kakaoIndex,
        selectedKakaoHistoryTypeItemKey,
    ]);

    // 메세지 내역(신) 디바운스 된 함수 정의
    const debouncedMonoMessageSearch = useMemo(() => {
        return debounce((value) => {
            dispatch(
                getMonoMessageHistoryAction({
                    params: setMessageParams({
                        date: moment(date).format('YYYYMM'),
                        page: monoMessageIndex,
                        keyword: value,
                        job_type: finalJobType(selectedMessageTypeItemKey),
                        type: selectedHistoryTypeItemKey || 'send_history',
                    }),
                    type: selectedHistoryTypeItemKey || 'send_history',
                }),
            );
            // count
            dispatch(
                getMonoMessageHistoryCountAction({
                    params: setMessageCountParams({
                        date: moment(date).format('YYYYMM'),
                        keyword: value,
                        job_type: finalJobType(selectedMessageTypeItemKey),
                    }),
                    type: selectedHistoryTypeItemKey || 'send_history',
                }),
            );
        }, 500);
    }, [
        date,
        monoMessageIndex,
        selectedHistoryTypeItemKey,
        selectedMessageTypeItemKey,
    ]);

    // 알림톡 키워드 검색 함수
    const onKakaoAlimKeywordChange = (e) => {
        setScrollPosition('kakao_alim_talk', 0);
        setIndex(0);
        setKakaoIndex(0);
        setResetKey((prev) => prev + 1); // 검색 시 스크롤 강제 초기화
        setKakaoKeyword(e.target.value);
        debouncedSearch(e.target.value);
    };

    // 메세지 내역(신) 키워드 검색 함수
    const onMonoMessageKeywordChange = (e) => {
        setScrollPosition('message', 0);
        setMonoMessageIndex(0);
        setResetKey((prev) => prev + 1); // 검색 시 스크롤 강제 초기화
        setMonoMessageKeyword(e.target.value);
        debouncedMonoMessageSearch(e.target.value);
    };

    // 운톡 푸쉬 알림의 setForm
    const setForm = (started_dttm, ended_dttm, pushFilter, index) => {
        let form = new FormData();
        form.append('page_size', String(50));
        form.append('page_index', String(index));
        form.append('started_dttm', String(started_dttm));
        form.append('finished_dttm', String(ended_dttm));
        form.append('status', 'all');
        // form.append("keyword", pushFilter ? String(pushFilter) : null);
        form.append('sort_properties', 'created_dttm');
        form.append('sort_desc', 'true');
        form.append('jgroup_key', `${jgroupKey}`);
        return form;
    };
    // 알림톡 내역의 setForm
    const setKakaoAlimTalkParams = ({
        search_start_time,
        search_end_time,
        page, // index를 나타냄
        keyword,
    }) => {
        return {
            size: pageSize,
            page,
            search_start_time,
            search_end_time,
            keyword: keyword || null,
            group_key: jgroupKey,
        };
    };
    // 알림톡 내역 count set params
    const setKakaoAlimTalkCountParams = ({
        search_start_time,
        search_end_time,
        keyword,
    }) => {
        return {
            search_start_time,
            search_end_time,
            keyword: keyword || null,
            group_key: jgroupKey,
        };
    };
    // 메세지 내역의 setForm (신)
    const setMessageParams = ({
        date,
        page, // index를 나타냄
        keyword,
        job_type,
        type, // 예약 내역 / 발송 내역을 나타냄
    }) => {
        return {
            date: moment(date).format('YYYYMM'),
            group_key: jgroupKey,
            search_start_time: moment(date, 'YYYYMM')
                .startOf('month')
                .toISOString(),
            search_end_time: moment(date, 'YYYYMM')
                .endOf('month')
                .toISOString(),
            page,
            keyword,
            size: type === 'reserved_history' ? bulkPageSize : pageSize, // 예약내역은 5000개, 발송내역은 50개
            job_type,
        };
    };
    // 메세지 내역 (신) count set params
    const setMessageCountParams = ({ date, keyword, job_type }) => {
        return {
            date: moment(date).format('YYYYMM'),
            group_key: jgroupKey,
            search_start_time: moment(date, 'YYYYMM')
                .startOf('month')
                .toISOString(),
            search_end_time: moment(date, 'YYYYMM')
                .endOf('month')
                .toISOString(),
            keyword,
            job_type,
        };
    };

    /** 실제 필터링이 구현된 함수
     * @param message 메시지
     * @param filter 입력된 키워드
     * @return message
     */
    const filterMessage = (message, filter) => {
        let addressee =
            message.PHONE || message.TR_PHONE || message.rcpt_data || '';
        let msg = message.MSG || message.TR_MSG || message.message || '';
        if (
            addressee.trim().includes(filter.replaceAll('-', '')) ||
            msg.trim().includes(filter)
        ) {
            return message;
        } else {
            return null;
        }
    };

    /** 스크롤이 테이블의 끝에 닿으면 Index를 증가시키는 함수 */
    const handleIndex = () => {
        switch (tab) {
            case 'message':
                {
                    if (!isLegacy) {
                        setMonoMessageIndex((index) => index + 1);
                    }
                }
                break;
            case 'push_notification':
                {
                    setIndex((index) => index + 1);
                }
                break;
            case 'kakao_alim_talk':
                {
                    setKakaoIndex((index) => index + 1);
                }
                break;
        }
    };

    /** 문자 메세지 내역(신)에서 체크박스 선택 시 동작하는 함수 */
    const handleRowSelectionChange = (keys, rows) => {
        setSelectedRowKeys(keys);
        setSelectedRows(rows);
    };

    const openDeleteReservedModal = () => {
        if (!selectedRows.length) {
            message.warning('삭제할 예약 내역을 선택해주세요');
            return;
        }
        setReservationDeleteOpen(true);
    };

    /** 문자 메세지 내역(신)에서 예약 삭제 버튼 누를 때 동작하는 함수 */
    const deleteReservedMonoMessage = () => {
        // 예약 내역이 존재하지 않는다면 return
        if (!selectedRows.length) return;
        const deletable = selectedRows.filter(
            (item) => item.status !== 'DOING',
        );
        if (!deletable.length) {
            message.warning('전송중 상태만 선택되어 삭제할 항목이 없습니다.');
            setReservationDeleteOpen(false);
            return;
        }
        dispatch(
            deleteReservedMonoMessageAction({
                job_ids: deletable.map((item) => item.job_id),
            }),
        );
        setReservationDeleteOpen(false);
    };

    /** 필터링을 위해 사용되는 함수
     * @param list 불러온 메시지 내역
     */
    const filterMessageData = (list) => {
        if (filter) {
            return list.filter((message) => {
                return filterMessage(message, filter);
            });
        } else {
            return list;
        }
    };

    /** 푸시 알림에서 날짜를 입력 후 확인 버튼을 누르면 호출되는 함수
     * @param value 폼에 입력한 값
     */
    const onFinish = (value) => {
        // date에 최신 날짜 데이터 업데이트 해주기
        setDate(moment(value.message_month));

        setScrollPosition(tab, 0);
        // 현재 탭의 index만 초기화 - 다른 탭에 영향 안주도록
        if (tab === 'push_notification') {
            setIndex(0);
        } else if (tab === 'kakao_alim_talk') {
            setKakaoIndex(0);
        } else if (tab === 'message') {
            setMonoMessageIndex(0);
        }
        switch (tab) {
            case 'message':
                const isLegacyStandard = isLegacyMessageHistoryDate(
                    moment(value.message_month ?? new Date(), 'YYYYMM')
                        .endOf('month')
                        .toISOString(),
                );
                if (isLegacyStandard) {
                    dispatch(
                        getMessageHistoryAction({
                            date: moment(
                                value.message_month ?? new Date(),
                            ).format('YYYYMM'),
                            jgroup_key: jgroupKey,
                            group_key: jgroupKey,
                            search_start_time: moment(
                                value.message_month ?? new Date(),
                                'YYYYMM',
                            )
                                .startOf('month')
                                .toISOString(),
                            search_end_time: moment(
                                value.message_month ?? new Date(),
                                'YYYYMM',
                            )
                                .endOf('month')
                                .toISOString(),
                        }),
                    );
                    setMessageData([]);
                } else {
                    setMonoMessageData(null); // 날짜 변경 시 기존 데이터 초기화
                    dispatch(
                        getMonoMessageHistoryAction({
                            params: setMessageParams({
                                date: moment(
                                    value.message_month ?? new Date(),
                                ).format('YYYYMM'),
                                page: 0,
                                keyword: monoMessageKeyword,
                                job_type: finalJobType(
                                    selectedMessageTypeItemKey,
                                ),
                                type:
                                    selectedHistoryTypeItemKey ||
                                    'send_history',
                            }),
                            type: selectedHistoryTypeItemKey || 'send_history',
                        }),
                    );
                    dispatch(
                        getMonoMessageHistoryCountAction({
                            params: setMessageCountParams({
                                date: moment(
                                    value.message_month ?? new Date(),
                                ).format('YYYYMM'),
                                keyword: monoMessageKeyword,
                                job_type: finalJobType(
                                    selectedMessageTypeItemKey,
                                ),
                            }),
                            type: selectedHistoryTypeItemKey || 'send_history',
                        }),
                    );
                }

                break;
            case 'push_notification':
                // 유효성 검사 추가
                if (
                    moment(value.push_start_date).isAfter(
                        moment(value.push_end_date),
                    )
                ) {
                    message.error({
                        content: '시작일을 확인해주세요',
                        style: {
                            marginTop: '90vh',
                        },
                        duration: 1,
                    });
                    return;
                }
                if (
                    moment(value.push_end_date).isBefore(
                        moment(value.push_start_date),
                    )
                ) {
                    message.error({
                        content: '마감일을 확인해주세요',
                        style: {
                            marginTop: '90vh',
                        },
                        duration: 1,
                    });
                    return;
                }
                setPushStartDttm(value.push_start_date);
                setPushEndDttm(value.push_end_date);
                setPushData(null); // 날짜 변경 시 기존 데이터 초기화
                dispatch(
                    getPushNotificationHistoryAction(
                        setForm(
                            value.push_start_date,
                            value.push_end_date,
                            pushFilter,
                            0,
                        ),
                    ),
                );
                break;
            case 'kakao_alim_talk':
                // 유효성 검사 추가
                if (
                    moment(value.kakao_start_date).isAfter(
                        moment(value.kakao_end_date),
                    )
                ) {
                    message.error({
                        content: '시작일을 확인해주세요',
                        style: {
                            marginTop: '90vh',
                        },
                        duration: 1,
                    });
                    return;
                }
                if (
                    moment(value.kakao_end_date).isBefore(
                        moment(value.kakao_start_date),
                    )
                ) {
                    message.error({
                        content: '마감일을 확인해주세요',
                        style: {
                            marginTop: '90vh',
                        },
                        duration: 1,
                    });
                    return;
                }
                // 100일 체크 로직 추가
                if (
                    moment(value.kakao_end_date).diff(
                        moment(value.kakao_start_date),
                        'days',
                    ) > 100
                ) {
                    message.error({
                        content: '최대 100일까지만 조회 가능합니다.',
                        style: {
                            marginTop: '90vh',
                        },
                        duration: 1,
                    });
                    return;
                }
                setKakaoStartDttm(value.kakao_start_date);
                setKakaoEndDttm(value.kakao_end_date);
                setKakaoData(null); // 날짜 변경 시 기존 데이터 초기화
                dispatch(
                    getKakaoAlimTalkHistoryAction({
                        params: setKakaoAlimTalkParams({
                            search_start_time:
                                value.kakao_start_date.toISOString(),
                            search_end_time: value.kakao_end_date.toISOString(),
                            page: 0,
                            keyword: kakaoKeyword,
                        }),
                        type: selectedKakaoHistoryTypeItemKey,
                    }),
                );
                // count
                dispatch(
                    getKakaoAlimTalkCountAction({
                        params: setKakaoAlimTalkCountParams({
                            search_start_time:
                                value.kakao_start_date.toISOString(),
                            search_end_time: value.kakao_end_date.toISOString(),
                            keyword: kakaoKeyword,
                        }),
                        type: selectedKakaoHistoryTypeItemKey,
                    }),
                );
                break;
        }
    };

    // const onPushNotificationKeywordChange = _.debounce((e) => {
    //   dispatch(
    //     getPushNotificationHistoryAction(
    //       setForm(pushStartDttm, pushEndDttm, e.target.value, 0)
    //     )
    //   );
    //   setIndex(0);
    // }, 800);

    /** 문자 탭에서 전체 상품, SMS, LMS를 선택 */
    useEffect(() => {
        if (tab === 'message') {
            setMessageData(initMessageList());
        } else if (tab === 'push_notification') {
        }
    }, [tab, sendedMessageList, filter]);

    const initMessageList = () => {
        switch (selectedHistoryTypeItemKey) {
            case 'send_history': {
                switch (selectedMessageTypeItemKey) {
                    case 'total':
                        return filterMessageData(sendedMessageList);
                        break;
                    case 'sms':
                        return filterMessageData(sendedSmsList);
                        break;
                    // case "mms":
                    //   handleMessageData(mmsList);
                    //   break;
                    case 'lms':
                        return filterMessageData(sendedLmsList);
                        break;
                    case 'mms': // 메세지내역(구)에는 없어서 빈 배열
                        return [];
                        break;
                }
                break;
            }

            case 'reserved_history': {
                switch (selectedMessageTypeItemKey) {
                    case 'total':
                        return filterMessageData(reservedMessageList);
                        break;
                    case 'sms':
                        return filterMessageData(reservedSmsList);
                        break;
                    // case "mms":
                    //   handleMessageData(mmsList);
                    //   break;
                    case 'lms':
                        return filterMessageData(reservedLmsList);
                        break;
                    case 'mms':
                        return [];
                        break;
                }
                break;
            }
        }
    };

    useEffect(() => {
        setMessageData(initMessageList());
    }, [selectedHistoryTypeItemKey, selectedMessageTypeItemKey]);

    /** Page Index가 변경되면 그 다음 리스트를 가지고 옴 */
    // 운톡 푸쉬 알림
    useEffect(() => {
        if (index !== 0) {
            dispatch(
                getPushNotificationHistoryAction(
                    setForm(pushStartDttm, pushEndDttm, pushFilter, index),
                ),
            );
        }
    }, [index]);

    // 알림톡
    useEffect(() => {
        if (kakaoIndex !== 0) {
            dispatch(
                getKakaoAlimTalkHistoryAction({
                    params: setKakaoAlimTalkParams({
                        search_start_time: kakaoStartDttm.toISOString(),
                        search_end_time: kakaoEndDttm.toISOString(),
                        page: kakaoIndex,
                        keyword: kakaoKeyword,
                    }),
                    type: selectedKakaoHistoryTypeItemKey || 'logs',
                }),
            );
        }
    }, [kakaoIndex]);

    // 메세지 내역(신) 무한스크롤
    useEffect(() => {
        if (monoMessageIndex !== 0 && !isLegacy) {
            dispatch(
                getMonoMessageHistoryAction({
                    params: setMessageParams({
                        date: moment(date).format('YYYYMM'),
                        page: monoMessageIndex,
                        keyword: monoMessageKeyword,
                        job_type: finalJobType(selectedMessageTypeItemKey),
                        type: selectedHistoryTypeItemKey || 'send_history',
                    }),
                    type: selectedHistoryTypeItemKey || 'send_history',
                }),
            );
        }
    }, [monoMessageIndex]);

    const filteredMessageList = initMessageList();

    // 조회된 목록 count 변수
    const searchLength = useMemo(() => {
        if (tab === 'message') {
            if (isLegacy) {
                return filteredMessageList?.length ?? null;
            }
            return monoMessageCount ?? null;
        }
        if (tab === 'push_notification') {
            return pushNotificationList?.lamb_total_count ?? null;
        }
        if (tab === 'kakao_alim_talk') {
            return kakaoAlimTalkCount.count ?? null;
        }
        return null;
    }, [
        filteredMessageList,
        pushNotificationList,
        tab,
        kakaoAlimTalkCount,
        selectedKakaoHistoryTypeItemKey,
        monoMessageCount,
        monoMessageList,
    ]);

    /** 가장 처음 메세지 내역 접근 할 떄 dispatch로 내역 전체 가져오기 */
    useEffect(() => {
        let tableHeight = document.getElementById('message_table').clientHeight;
        setHeight(tableHeight - 44);
        const updateHeight = () => {
            tableHeight = document.getElementById('message_table').clientHeight;
            setHeight(tableHeight - 44);
        };
        // ResizeObserver (윈도우 확대/축소 시 테이블 높이 재설정)
        const el = document.getElementById('message_table');
        let ro;
        if (el && 'ResizeObserver' in window) {
            ro = new ResizeObserver(
                debounce(() => {
                    // 윈도우 확대/축소 시 과도한 호출 방지
                    const h = el.clientHeight;
                    setHeight(h - 44);
                }, 100),
            );
            ro.observe(el);
        }
        window.addEventListener('resize', updateHeight);
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        const started_dttm = new Date(year, month, 1);
        const ended_dttm = new Date(year, month + 1, 0);
        setPushStartDttm(started_dttm);
        setPushEndDttm(ended_dttm);
        setKakaoStartDttm(started_dttm);
        setKakaoEndDttm(ended_dttm);
        // 메세지 내역 (구) 2025년 5월 31일까지는 이 요청을 한다.
        const searchStartTime = moment(date, 'YYYYMM')
            .startOf('month')
            .toISOString();
        const searchEndTime = moment(date, 'YYYYMM')
            .endOf('month')
            .toISOString();
        if (isLegacy) {
            dispatch(
                getMessageHistoryAction({
                    date: moment(date).format('YYYYMM'),
                    jgroup_key: jgroupKey,
                    group_key: jgroupKey,
                    search_start_time: searchStartTime,
                    search_end_time: searchEndTime,
                }),
            );
        } else {
            // 메세지 내역 (신) 그 이후부터는 이 요청.(6월부터!)
            dispatch(
                getMonoMessageHistoryAction({
                    params: setMessageParams({
                        date: moment(date).format('YYYYMM'),
                        page: 0,
                        keyword: null,
                        job_type: finalJobType(selectedMessageTypeItemKey),
                        type: selectedHistoryTypeItemKey || 'send_history',
                    }),
                    type: selectedHistoryTypeItemKey || 'send_history',
                }),
            );
            dispatch(
                getMonoMessageHistoryCountAction({
                    params: setMessageCountParams({
                        date: moment(date).format('YYYYMM'),
                        keyword: null,
                        job_type: finalJobType(selectedMessageTypeItemKey),
                    }),
                    type: selectedHistoryTypeItemKey || 'send_history',
                }),
            );
        }

        dispatch(
            getPushNotificationHistoryAction(
                setForm(started_dttm, ended_dttm, pushFilter, 0),
            ),
        );
        dispatch(
            getKakaoAlimTalkHistoryAction({
                params: setKakaoAlimTalkParams({
                    search_start_time: started_dttm.toISOString(),
                    search_end_time: ended_dttm.toISOString(),
                    page: 0,
                    keyword: null,
                }),
                type: selectedKakaoHistoryTypeItemKey || 'logs',
            }),
        );
        // count
        dispatch(
            getKakaoAlimTalkCountAction({
                params: setKakaoAlimTalkCountParams({
                    search_start_time: started_dttm.toISOString(),
                    search_end_time: ended_dttm.toISOString(),
                    keyword: null,
                }),
                type: selectedKakaoHistoryTypeItemKey || 'logs',
            }),
        );
        return () => {
            if (ro) ro.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    useEffect(() => {
        /** 무한 스크롤의 경우 */
        if (pushData && index !== 0) {
            setPushData((pushData) => {
                return [...pushData, ...pushNotificationList.lamb_list];
            });
        } else {
            pushNotificationList
                ? setPushData(pushNotificationList.lamb_list)
                : null;
        }
    }, [pushNotificationList]);

    useEffect(() => {
        /** 무한 스크롤의 경우 */
        if (kakaoData && kakaoIndex !== 0) {
            setKakaoData((kakaoData) => {
                return [...kakaoData, ...kakaoAlimTalkList];
            });
        } else {
            kakaoAlimTalkList ? setKakaoData(kakaoAlimTalkList) : null;
        }
    }, [kakaoAlimTalkList]);

    // 메세지 내역(신)의 테이블 데이터 관리
    useEffect(() => {
        /** 무한 스크롤의 경우 */
        if (monoMessageData && monoMessageIndex !== 0) {
            setMonoMessageData((monoData) => {
                return [...monoData, ...monoMessageList];
            });
        } else {
            monoMessageList ? setMonoMessageData(monoMessageList) : null;
        }
    }, [monoMessageList]);

    /** 언마운트 시 디바운스 정리 */
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    /** 메세지 내역 (신) 언마운트 시 디바운스 정리 */
    useEffect(() => {
        return () => {
            debouncedMonoMessageSearch.cancel();
        };
    }, [debouncedMonoMessageSearch]);

    /** 데이터 / 탭 바뀌면 선택된 체크박스 내역 초기화 */
    useEffect(() => {
        setSelectedRowKeys([]);
        setSelectedRows([]);
    }, [
        filteredMessageList,
        monoMessageList,
        pushNotificationList,
        kakaoAlimTalkList,
        tab,
    ]);

    useEffect(() => {
        // 삭제 실패한 경우
        if (deleteReservedMonoMessageError) {
            message.destroy();
            message.error({
                content:
                    '예약 문자 삭제에 실패했습니다.  문제가 계속 된다면 브로제이에 문의해주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            // 플래그 리셋
            dispatch(clearDeleteReservedMonoMessageStatusAction());
            return;
        }
        // 예약 삭제 완료되지 않은 경우
        if (!deleteReservedMonoMessageDone) return;

        // 모든 조건에서 성공 시에
        message.destroy();
        message.success({
            content: '예약 문자 삭제가 완료되었습니다.',
            style: {
                marginTop: '90vh',
            },
            duration: 1,
        });
        dispatch(
            getMonoMessageHistoryAction({
                params: setMessageParams({
                    date: moment(date).format('YYYYMM'),
                    page: 0,
                    keyword: monoMessageKeyword ?? null,
                    job_type: finalJobType(selectedMessageTypeItemKey),
                }),
                type: 'reserved_history',
            }),
        );

        dispatch(
            getMonoMessageHistoryCountAction({
                params: setMessageCountParams({
                    date: moment(date).format('YYYYMM'),
                    keyword: monoMessageKeyword ?? null,
                    job_type: finalJobType(selectedMessageTypeItemKey),
                }),
                type: 'reserved_history',
            }),
        );
        // 성공 플래그 리셋
        dispatch(clearDeleteReservedMonoMessageStatusAction());
        setSelectedRowKeys([]);
        setSelectedRows([]);
    }, [deleteReservedMonoMessageDone, deleteReservedMonoMessageError]);

    // datepicker section
    const DatePickerComponent = () => {
        switch (tab) {
            case 'message':
                return (
                    <DateContainer>
                        <Form onFinish={onFinish} style={{ display: 'flex' }}>
                            <Form.Item name="message_month">
                                <DatePicker
                                    placeholder=""
                                    picker="month"
                                    defaultValue={date}
                                    locale={locale}
                                    key="message_month"
                                />
                            </Form.Item>

                            <Spacer />
                            <CustomButton
                                height="30px"
                                width="71px"
                                fontSize="14px"
                                text="확인"
                                borderRadius="5px"
                                htmlType="submit"
                            />
                        </Form>
                    </DateContainer>
                );
            case 'push_notification':
                return (
                    <DateContainer>
                        <Form onFinish={onFinish} style={{ display: 'flex' }}>
                            <Form.Item
                                name="push_start_date"
                                initialValue={moment(pushStartDttm)}
                            >
                                <DatePicker
                                    placeholder=""
                                    value={
                                        pushStartDttm
                                            ? moment(pushStartDttm)
                                            : null
                                    }
                                    defaultValue={
                                        pushStartDttm
                                            ? moment(pushStartDttm)
                                            : null
                                    }
                                    locale={locale}
                                    key="push_start_date"
                                    onChange={(value) => {
                                        setPushStartDttm(value);
                                        handlePushStartChange(
                                            value,
                                            pushEndDttm,
                                        );
                                    }}
                                    open={startPushOpen}
                                    onOpenChange={handlePushStartOpenChange}
                                />
                            </Form.Item>
                            <Spacer />
                            <Form.Item
                                name="push_end_date"
                                initialValue={moment(pushEndDttm)}
                            >
                                <DatePicker
                                    placeholder=""
                                    value={
                                        pushEndDttm ? moment(pushEndDttm) : null
                                    }
                                    defaultValue={
                                        pushEndDttm ? moment(pushEndDttm) : null
                                    }
                                    locale={locale}
                                    key="push_end_date"
                                    onChange={(value) => {
                                        setPushEndDttm(value);
                                        handlePushEndChange(
                                            value,
                                            pushStartDttm,
                                        );
                                    }}
                                    open={endPushOpen}
                                    onOpenChange={handlePushEndOpenChange}
                                />
                            </Form.Item>
                            <Spacer />
                            <CustomButton
                                height="30px"
                                width="71px"
                                fontSize="14px"
                                text="확인"
                                borderRadius="5px"
                                htmlType="submit"
                            />
                        </Form>
                    </DateContainer>
                );
            case 'kakao_alim_talk':
                return (
                    <DateContainer>
                        <Form onFinish={onFinish} style={{ display: 'flex' }}>
                            <Form.Item
                                name="kakao_start_date"
                                initialValue={moment(kakaoStartDttm)}
                            >
                                <DatePicker
                                    placeholder=""
                                    value={
                                        kakaoStartDttm
                                            ? moment(kakaoStartDttm)
                                            : null
                                    }
                                    defaultValue={
                                        kakaoStartDttm
                                            ? moment(kakaoStartDttm)
                                            : null
                                    }
                                    locale={locale}
                                    key="kakao_start_date"
                                    onChange={(value) => {
                                        setKakaoStartDttm(value);
                                        handleKakaoStartChange(
                                            value,
                                            kakaoEndDttm,
                                        );
                                    }}
                                    open={startKakaoOpen}
                                    onOpenChange={handleKakaoStartOpenChange}
                                />
                            </Form.Item>
                            <Spacer />
                            <Form.Item
                                name="kakao_end_date"
                                initialValue={moment(kakaoEndDttm)}
                            >
                                {/* 추가 수정 필요 */}
                                <DatePicker
                                    placeholder=""
                                    value={
                                        kakaoEndDttm
                                            ? moment(kakaoEndDttm)
                                            : null
                                    }
                                    defaultValue={
                                        kakaoEndDttm
                                            ? moment(kakaoEndDttm)
                                            : null
                                    }
                                    locale={locale}
                                    key="kakao_end_date"
                                    onChange={(value) => {
                                        setKakaoEndDttm(value);
                                        handleKakaoEndChange(
                                            value,
                                            kakaoStartDttm,
                                        );
                                    }}
                                    open={endKakaoOpen}
                                    onOpenChange={handleKakaoEndOpenChange}
                                />
                            </Form.Item>
                            <Spacer />
                            <CustomButton
                                height="30px"
                                width="71px"
                                fontSize="14px"
                                text="확인"
                                borderRadius="5px"
                                htmlType="submit"
                            />
                        </Form>
                    </DateContainer>
                );
            default:
                return null;
        }
    };

    // caution section
    const CautionSectionComponent = () => {
        switch (tab) {
            case 'message':
                return (
                    <Caution>
                        <Text size={12} color="#fff">
                            • &nbsp; 문자 발송 시 통신사 사정에 의해 발송결과에
                            대한{' '}
                            <Text size={12} style={{ fontWeight: 700 }}>
                                응답 대기 시간
                            </Text>
                            이 소요될 수 있습니다.
                        </Text>
                        <br />
                        <Text size={12} color="#fff">
                            • &nbsp; 전송 결과 완료 후 메시지 전송 실패 건은
                            사용한 충전금/포인트가 자동 환불 됩니다.{' '}
                            <Text
                                size={12}
                                color="#EB5252"
                                style={{ fontWeight: 700 }}
                            >
                                (약 2주 소요됩니다){' '}
                            </Text>
                        </Text>
                    </Caution>
                );
            case 'push_notification':
                return (
                    <Caution>
                        <Text size={12} color="#fff">
                            • &nbsp; 운톡 어플이 설치된 경우 푸쉬 알림이
                            전송됩니다.
                        </Text>
                        <br />
                        <Text size={12} color="#fff">
                            • &nbsp;{' '}
                            <Text size={12} color="#3B99F5">
                                운톡 푸시알림은 비용이 발생하지 않습니다.
                            </Text>
                        </Text>
                    </Caution>
                );
            case 'kakao_alim_talk':
                return (
                    <Caution>
                        <Text size={12} color="#fff">
                            • &nbsp; 알림톡 발송 시 시스템 사정에 의해
                            발송결과에 대한 응답 대기 시간이 소요될 수 있습니다.
                        </Text>
                        <br />
                        <Text size={12} color="#fff">
                            • &nbsp; 전송 결과 완료 후 알림톡 전송 실패 건은
                            사용한 충전금/포인트가 자동 환불 됩니다.
                            <Text size={12} color="#EB5252">
                                &nbsp; (약 2주 소요됩니다.)
                            </Text>
                        </Text>
                    </Caution>
                );
            default:
                return null;
        }
    };

    // table top section
    const TableTopSectionComponent = () => {
        switch (tab) {
            case 'message':
                return (
                    <React.Fragment>
                        <Dropdown
                            getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                            }
                            popupStyle={{ zIndex: 10500 }}
                            trigger={'click'}
                            overlay={
                                <HistoryTypeMenu
                                    handleChange={handleHistoryTypeMenuItem}
                                    tabType={'message'}
                                />
                            }
                            // position="relative"
                            overlayStyle={{ position: 'absolute' }}
                        >
                            <div
                                style={{
                                    background: '#4a4a4a',
                                    padding: '12px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    width: '141px',
                                    justifyContent: 'space-between',

                                    height: '32px',
                                    borderRadius: '3px',
                                }}
                            >
                                <Text color="#fff" size={12}>
                                    {
                                        HistoryTypeMenuItems[
                                            selectedHistoryTypeItemKey
                                        ]
                                    }
                                </Text>
                                <Icon
                                    width="12px"
                                    height="6px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/assets/images/icon/select/toggle_down.png'
                                    }
                                />
                            </div>
                        </Dropdown>
                        <Spacer />
                        <Dropdown
                            getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                            }
                            popupStyle={{ zIndex: 10500 }}
                            trigger={'click'}
                            overlay={
                                <MessageTypeMenu
                                    handleChange={handleMessageTypeMenuItem}
                                />
                            }
                            // position="relative"
                            overlayStyle={{ position: 'absolute' }}
                        >
                            <div
                                style={{
                                    background: '#4a4a4a',
                                    padding: '12px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    width: '141px',
                                    justifyContent: 'space-between',

                                    height: '32px',
                                    borderRadius: '3px',
                                }}
                            >
                                <Text color="#fff" size={12}>
                                    {
                                        MessageTypeMenuItems[
                                            selectedMessageTypeItemKey
                                        ]
                                    }
                                </Text>
                                <Icon
                                    width="12px"
                                    height="6px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/assets/images/icon/select/toggle_down.png'
                                    }
                                />
                            </div>
                        </Dropdown>
                        <Spacer />
                    </React.Fragment>
                );
            case 'push_notification':
                return null;
            case 'kakao_alim_talk':
                return (
                    <React.Fragment>
                        <Dropdown
                            getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                            }
                            popupStyle={{ zIndex: 10500 }}
                            trigger={'click'}
                            overlay={
                                <HistoryTypeMenu
                                    handleChange={handleHistoryTypeMenuItem}
                                    tabType={'kakao_alim_talk'}
                                />
                            }
                            // position="relative"
                            overlayStyle={{ position: 'absolute' }}
                        >
                            <div
                                style={{
                                    background: '#4a4a4a',
                                    padding: '12px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    width: '141px',
                                    justifyContent: 'space-between',

                                    height: '32px',
                                    borderRadius: '3px',
                                }}
                            >
                                <Text color="#fff" size={12}>
                                    {
                                        kakaoHistoryTypeMenuItems[
                                            selectedKakaoHistoryTypeItemKey
                                        ]
                                    }
                                </Text>
                                <Icon
                                    width="12px"
                                    height="6px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/assets/images/icon/select/toggle_down.png'
                                    }
                                />
                            </div>
                        </Dropdown>
                        <Spacer />
                    </React.Fragment>
                );
            default:
                return null;
        }
    };

    // table section
    const TableSectionComponent = () => {
        switch (tab) {
            case 'message':
                if (isLegacy) {
                    return (
                        <MessageTable
                            sendType={selectedHistoryTypeItemKey} // 발송 내역 / 예약 내역
                            tab={tab}
                            type={selectedMessageTypeItemKey}
                            tableData={filteredMessageList}
                            height={height}
                            resetKey={resetKey}
                        />
                    );
                }
                // 메세지 내역(신)
                return (
                    <MessageTable
                        sendType={selectedHistoryTypeItemKey} // 발송 내역 / 예약 내역
                        tab={tab}
                        type={selectedMessageTypeItemKey}
                        tableData={monoMessageData}
                        height={height}
                        rowSelection={
                            selectedHistoryTypeItemKey === 'reserved_history'
                                ? {
                                      selectedRowKeys,
                                      onChange: handleRowSelectionChange,
                                      preserveSelectedRowKeys: false,
                                  }
                                : undefined
                        } // 체크박스 추가를 위한 속성
                        resetKey={resetKey}
                        // 발송/예약 내역 모두 무한 스크롤 구현
                        handleIndex={handleIndex}
                        index={monoMessageIndex}
                        scrollPosition={getScrollPosition('message')}
                        setScrollPosition={(pos) =>
                            setScrollPosition('message', pos)
                        }
                        totalIndex={
                            selectedHistoryTypeItemKey === 'reserved_history'
                                ? Math.ceil(monoMessageCount / bulkPageSize) - 1
                                : Math.ceil(monoMessageCount / pageSize) - 1
                        }
                    />
                );
            case 'push_notification':
                return (
                    <MessageTable
                        sendType={selectedHistoryTypeItemKey}
                        tab={tab}
                        tableData={pushData}
                        handleIndex={handleIndex}
                        index={index}
                        totalIndex={pushNotificationList.page_total_count - 1}
                        scrollPosition={getScrollPosition('push_notification')}
                        setScrollPosition={(pos) =>
                            setScrollPosition('push_notification', pos)
                        }
                        height={height}
                        resetKey={resetKey}
                    />
                );
            case 'kakao_alim_talk':
                return (
                    <MessageTable
                        sendType={selectedKakaoHistoryTypeItemKey}
                        tab={tab}
                        tableData={kakaoData}
                        handleIndex={handleIndex}
                        index={kakaoIndex}
                        totalIndex={
                            Math.ceil(kakaoAlimTalkCount.count / pageSize) - 1
                        }
                        scrollPosition={getScrollPosition('kakao_alim_talk')}
                        setScrollPosition={(pos) =>
                            setScrollPosition('kakao_alim_talk', pos)
                        }
                        height={height}
                        resetKey={resetKey}
                    />
                );
            default:
                return null;
        }
    };

    // table right btn section
    const TableRightSectionComponent = () => {
        switch (tab) {
            case 'message':
                {
                    // 메세지내역 (구) 일때는 disabled
                    if (selectedHistoryTypeItemKey === 'send_history') {
                        return (
                            <GuideBtn
                                onClick={() => {
                                    window.open(
                                        'https://broj.notion.site/KT-1b386ca40119808aae0ed3a4bf30cb2a',
                                        '_blank',
                                    );
                                }}
                                style={{
                                    opacity: isLegacy ? 0.2 : 'unset',
                                    pointerEvents: isLegacy ? 'none' : 'auto',
                                }}
                            >
                                실패코드가이드
                            </GuideBtn>
                        );
                    } else {
                        return (
                            <DeleteButton
                                onClick={openDeleteReservedModal}
                                style={{
                                    opacity: isLegacy ? 0.2 : 'unset',
                                    pointerEvents: isLegacy ? 'none' : 'auto',
                                    width: selectedRows.length > 0 ? '140px' : '105px',
                                }}
                            >
                                <Icon
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/assets/images/icon/white/trash.png'
                                    }
                                />
                                <Text color={commonTheme.font.black5}>
                                    예약 삭제 {selectedRows.length > 0 && `(${selectedRows.length})`}
                                </Text>
                            </DeleteButton>
                        );
                    }
                }
                break;
            case 'kakao_alim_talk':
                return (
                    <GuideBtn
                        onClick={() => {
                            window.open(
                                'https://broj.notion.site/1d586ca401198024a824cc6bcb8f6af2?source=copy_link',
                                '_blank',
                            );
                        }}
                    >
                        실패코드가이드
                    </GuideBtn>
                );
            default:
                return null;
        }
    };

    return (
        <Layout
            className="message-send"
            style={{ overflow: 'auto', maxHeight: 'calc(100% - 90px)' }}
        >
            <Header
                style={{
                    display: 'block',
                    height: 'auto',
                    position: 'relative',
                }}
            >
                <Tabs defaultActiveKey="message" onChange={onTabChange}>
                    <TabPane tab="문자" key="message"></TabPane>
                    <TabPane
                        tab="운톡 푸쉬 알림"
                        key="push_notification"
                    ></TabPane>
                    <TabPane tab="알림톡" key="kakao_alim_talk"></TabPane>
                </Tabs>
                <Spacer size={12} />
                <ConfigProvider locale={locale}>
                    {/* 탭에 따른 분기처리 */}
                    {DatePickerComponent()}
                </ConfigProvider>
                {/* 탭에 따른 분기처리 */}
                {CautionSectionComponent()}
                <Spacer size={14} />
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                    }}
                >
                    {/* 탭에 따른 분기처리 */}
                    <div style={{ display: 'flex' }}>
                        {TableTopSectionComponent()}
                        <MessageSearchBar
                            tab={tab}
                            onChange={
                                (e) => handleKeywordChange(e, tab)
                                // tab === 'message'
                                //     ? onMessageKeywordChange
                                //     : onKakaoAlimKeywordChange
                            }
                            searchLength={searchLength}
                            value={
                                tab === 'message'
                                    ? isLegacy
                                        ? filter ?? ''
                                        : monoMessageKeyword ?? ''
                                    : tab === 'kakao_alim_talk'
                                    ? kakaoKeyword ?? ''
                                    : ''
                            }
                        />
                    </div>
                    {/* 테이블 오른쪽 버튼 섹션 */}
                    {TableRightSectionComponent()}
                </div>
            </Header>
            <Spacer size={4.5} />
            <Content id="message_table">
                {(getMessageHistoryLoading ||
                    getPushNotificationHistoryLoading ||
                    getKakaoAlimTalkHistoryLoading ||
                    getKakaoAlimTalkCountLoading ||
                    getMonoMessageHistoryLoading ||
                    deleteReservedMonoMessageLoading) && <CustomSpinner />}
                {/* 탭에 따른 분기처리 */}
                {TableSectionComponent()}
            </Content>
            {reservationDeleteOpen && (
                <NoticeModal
                    multipleScreen={false}
                    multipleButton={true}
                    title="예약 문자 삭제"
                    headerIcon="/assets/images/icon/white/alert.png"
                    primaryColor="#EB5252"
                    firstButtonText="취소"
                    secondButtonText="확인"
                    warningText="* 이 작업은 되돌릴 수 없습니다."
                    body={(() => {
                        const doingCount = selectedRows.filter(
                            (r) => r.status === 'DOING',
                        ).length;
                        const totalCount = selectedRows.length;
                        const deletableCount = totalCount - doingCount;

                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <Text color="#000">
                                    전송중 상태를 제외한{' '}
                                    <Text color="#000">{deletableCount}개</Text>
                                    의 내역을 삭제합니다.
                                </Text>
                                <Spacer />
                                <Text color="#000" fontWeight="800">
                                    * 정말로 삭제하시겠습니까?
                                </Text>
                            </div>
                        );
                    })()}
                    handleFirstButton={() => setReservationDeleteOpen(false)}
                    handleSecondButton={deleteReservedMonoMessage}
                />
            )}
        </Layout>
    );
};

const DateContainer = styled.div`
  display: flex;
  position: absolute;
  right: 0px;
  top: 10px;
`;

const Caution = styled.div`
  width: 100%;
  padding: 12px;
  background: #4a4a4a;
  border-radius: 5px;
`;

const GuideBtn = styled.span`
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    text-decoration: underline;
    color: #fff;
    cursor: pointer;
`;

const DeleteButton = styled.button`
  width: 105px;
  height: 32px;
  background: ${commonTheme.background.black7};
  border: none;
  border-radius: 3px;
  padding: 7px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  :hover {
    cursor: pointer;
  }
`;

export default MessageHistory;
